(() => {
 const update = cart => {
  document.querySelectorAll('.gb-offer-progress, [data-gb-offer-shipping]').forEach(element => {
   if (cart.currency !== element.dataset.currency) return;
   const threshold = Number(element.dataset.threshold), remaining = Math.max(0, threshold - cart.total_price);
   const money = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:cart.currency}).format(remaining / 100);
   element.querySelector('[data-progress-message]').textContent = remaining ? `You're ${money} away from free shipping` : "You've reached the free shipping threshold";
   const bar = element.querySelector('progress');
   if (bar) bar.value = Math.min(100, cart.total_price / threshold * 100);
  });
 };
 let timer;
 const refresh = event => {
  if (event.detail?.cart?.total_price !== undefined) { update(event.detail.cart); return; }
  clearTimeout(timer); timer = setTimeout(() => fetch((window.Shopify?.routes?.root || '/')+'cart.js').then(r=>r.json()).then(update).catch(()=>{}),200);
 };
 ['cart:refresh','product:added','gb:product-added','line-item:change:end'].forEach(name => document.addEventListener(name,refresh));
})();
